import styled from 'styled-components';

export const PageWrapper = styled.div`
	overflow-y: auto;
	width: 100%;
	height: 100vh;
`;
